<h1 mat-dialog-title class="se-dialog-header">{{ data.message }}</h1>
<div mat-dialog-content style="width: 100%">
    <div [formGroup]="form">
        <mat-form-field>
            <mat-label>{{ "Templates" | translate }}</mat-label>
            <mat-select formControlName="template">
                @for (item of data.templates; track item) {
                    <mat-option [value]="item.guid">{{ item.description }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</div>
<mat-dialog-actions class="dialog-actions">
    <button (click)="closeDialog()" color="primary" mat-button mat-dialog-close>
        {{ cancelLabel | translate }}
    </button>
    <button (click)="confirm()" color="primary" mat-button [disabled]="!form.valid">{{ confirmLabel | translate }}
    </button>
</mat-dialog-actions>
